module.exports = __webpack_public_path__ + "media/images/store_badges/google_play/google_play_it-0c5f66c1ecdffb2afbc6c5e6d4618284.png";